import { render, staticRenderFns } from "./asyncCollegeModal.vue?vue&type=template&id=44569486&scoped=true&"
import script from "./asyncCollegeModal.vue?vue&type=script&lang=js&"
export * from "./asyncCollegeModal.vue?vue&type=script&lang=js&"
import style0 from "./asyncCollegeModal.vue?vue&type=style&index=0&id=44569486&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44569486",
  null
  
)

export default component.exports